import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { BlazeTableAction, BlazeTableActionType } from '@blaze-shared/datasets-domain';
import { type DatasetColumn } from '@blaze-shared/schema-domain';

@Component({
  selector: 'blaze-table-column-actions-menu',
  templateUrl: './table-column-actions-menu.component.html',
  styleUrls: ['./table-column-actions-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableColumnActionsMenuComponent {
  @Input() column?: DatasetColumn;
  @Input() columnsCount!: number;
  @Input() isProtectedColumn!: boolean;
  @Input() isDisplayColumnProtected?: boolean;
  @Input() notEditable? = false;
  @Input() referencesCount = 0;
  @Output() actionSelected = new EventEmitter<BlazeTableAction>();

  readonly ActionType = BlazeTableActionType;

  selectMenuItem(type: BlazeTableActionType): void {
    if (this.column) {
      this.actionSelected.emit({ sourceColumn: this.column, type });
    }
  }
}
